import {Controller} from "stimulus"

export default class extends Controller {
  down(event) {
    event.preventDefault();
    const target = event.target.closest(".machine-product-list-container").nextElementSibling;
    if (target) {
      target.scrollIntoView({block: "start", behavior: "smooth"});
    }
  }
}
